import { render, staticRenderFns } from "./link-commerce.vue?vue&type=template&id=a20a262e&scoped=true&"
import script from "./link-commerce.vue?vue&type=script&lang=js&"
export * from "./link-commerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20a262e",
  null
  
)

export default component.exports